import { getPath } from '@/router/common'

const baseUrl = {
  title: '用户打印模板',
  path: 'rptMana'
}

export default [
  {
    path: getPath('userPrintTemplate', baseUrl),
    name: 'UserPrintTemplate',
    component: () =>
      import(
        /* webpackChunkName: "userPrintTemplate" */ '@/views/rptMana/userPrintTemplate/index.vue'
      ),
    meta: {
      title: '用户打印模板'
    }
  },
  {
    path: getPath('rptModelMana', baseUrl),
    name: 'rptModelMana',
    component: () =>
      import(
        /* webpackChunkName: "rptModelMana" */ '@/views/rptMana/rptModelMana/index.vue'
      ),
    meta: {
      title: '报表模板管理'
    }
  },
  {
    path: getPath('rptModelManaEdit', baseUrl),
    name: 'RptManarptModelManaEdit',
    component: () =>
      import(
        /* webpackChunkName: "rptModelManaEdit" */ '@/views/rptMana/rptModelManaEdit/index.vue'
      ),
    meta: {
      title: '报表模板管理新增'
    }
  },
  {
    path: getPath('rptDesign', baseUrl),
    name: 'rptDesign',
    component: () =>
      import(
        /* webpackChunkName: "rptDesign" */ '@/views/rptMana/rptDesign/index.vue'
      ),
    meta: {
      title: '编辑模板'
    }
  },
  {
    path: getPath('dzmd', baseUrl),
    name: 'rptMana_dzmd',
    component: () => import(/* webpackChunkName: "rptMana_dzmd" */ '@/views/rptMana/dzmd/index.vue'),
    meta: {
      title: '电子面单'
    }
  },
  {
    path: getPath('PrinterSetting', baseUrl),
    name: 'rptMana_PrinterSetting',
    component: () => import(/* webpackChunkName: "rptMana_PrinterSetting" */ '@/views/rptMana/printerSetting/index.vue'),
    meta: {
      title: '打印设置'
    }
  }
]
